import { tv } from 'tailwind-variants';

/**
 * Styles for the BaseCheckbox component using tailwind-variants
 * Uses design tokens for check-radio controls
 */
const baseCheckboxStyles = tv({
    slots: {
        // Base container styles
        // Base styles using component tokens
        base: `iris:size-(--comp-size-box-check-radio-control)
      iris:cursor-pointer
      iris:rounded-(--comp-size-radius-checkbox-control)
      iris:border
      iris:p-0.5
      iris:shadow-none
      iris:outline-none`,
        // Checkmark indicator styles
        indicator: `
      iris:flex
      iris:h-full
      iris:w-full
      iris:text-(--comp-color-content-check-radio-control-selected)
      `,
    },
    variants: {
        inverse: {
            false: {
                //Checked state
                base: `iris:border-(--comp-color-border-check-radio-control-rest)
          iris:bg-(--comp-color-background-check-radio-control-rest)
          iris:group-data-[state=checked]:border-(--comp-color-border-check-radio-control-selected)
          iris:group-data-[state=checked]:bg-(--comp-color-background-check-radio-control-selected)`,
            },
            true: {
                base: 
                //Checked state
                `iris:border-(--comp-color-border-check-radio-control-inverse-rest)
          iris:bg-(--comp-color-background-check-radio-control-inverse-rest)
          iris:group-data-[state=checked]:border-(--comp-color-border-check-radio-control-inverse-selected)
          iris:group-data-[state=checked]:bg-(--comp-color-background-check-radio-control-inverse-selected)`,
                indicator: "iris:text-(--comp-color-content-check-radio-control-inverse-selected)",
            },
        },
        disabled: {
            true: "",
            false: "",
        },
    },
    compoundVariants: [
        {
            inverse: false,
            disabled: false,
            class: {
                // Interactive states
                base: `iris:group-hover:border-(--comp-color-border-check-radio-control-hover)
          iris:group-hover:bg-(--comp-color-background-check-radio-control-hover)`,
            },
        },
        {
            inverse: true,
            disabled: false,
            class: {
                // Interactive states
                base: `iris:group-hover:border-(--comp-color-border-check-radio-control-inverse-hover)
          iris:group-hover:bg-(--comp-color-background-check-radio-control-inverse-hover)`,
            },
        },
    ],
});

export { baseCheckboxStyles as default };
